import React from 'react';
import * as d3 from 'd3';
import axios from 'axios';
// import perksProgram from './perksProgram.json';
// import perks from './perks.json';
import {Dropdown} from 'semantic-ui-react';
import { prepareDataForValidation } from 'formik';
import GroupChart from './Charts/GroupChart';
// import PieChart from './PieChart';
import StackChart from './Charts/StackChart';
import ReactToPdf from 'react-to-pdf';

export default class ActiveInactiveUsers extends React.Component {
    constructor(props){
        super(props);
        this.pdfRef = React.createRef();
        this.state = {
            allTeam : props.allTeam,
            teamList : props.team,
            allEmployee : props.allEmployee,
            employeeList : props.employee,

            selected: false,

            chartType: 1,
            accessToken: localStorage.getItem('accessToken'),
            groupChartData: null,
            stackChartData: null,
            // pieChartData: null,
            dropdownOptions : [],
            description: [],
            url: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080',
        }
    }

    componentDidMount(){
        var groupDat = []
        var groupColumns = ["Team", "Active", "Inactive"]
        var stackedStart = "name,Active,Inactive\r"
        var stackedEnd = "";
        var teamEmployees;
        var activeEmployees = 0;
        var inactiveEmployees = 0;
        var dataList = []
        var desc = []
        this.state.teamList.forEach(team => {
            teamEmployees = this.state.employeeList.filter(employee => {
                return employee.teamId === team._id
            })
            teamEmployees.forEach(employee => {
                if(employee.status === 'active'){
                    activeEmployees++;
                }else{
                    inactiveEmployees++
                }
            })
            desc.push(`Total employees in ${team.name}: ${activeEmployees+inactiveEmployees}`)
            dataList.push({
                name: team.name,
                active: activeEmployees,
                inactive: inactiveEmployees
            })
        });
        this.setState({description: desc})
        var sortedData = dataList.sort(function(a,b){
            return (a.active+a.inactive) - (b.active+b.inactive)
        });
        sortedData.forEach(obj => {
            stackedEnd += obj.name + ',' + String(obj.active) + ',' + String(obj.inactive) + "\r";
            groupDat.push({
                Team: obj.name,
                Active: Number(obj.active),
                Inactive: Number(obj.inactive)
            });
            // groupColumns.push(obj.name)
        })

        var stack = stackedStart+stackedEnd;
        var group = {
            dat: groupDat,
            columns: groupColumns,
            y: "Num Employees"
        }
        this.setState({stackChartData: stack})
        this.setState({groupChartData: group})
        this.setState({selected: true})
    }

    chartTypeChanged(event, value) {
        this.setState({selected: false})
        this.setState({chartType: value.value})
        this.setState({selected: true})
    }

    render(){
        return (
            <div style={{flex:1, flexDirection: 'column'}}>
                <div style={{flex:1, flexDirection:'row', padding:10}}>
                            <span style={{flex:1}}>Select Chart type:</span>
                            <span style={{flex:3, paddingLeft:20}}>
                                < Dropdown
                                placeholder= 'Select Chart Type'
                                name = 'Select Chart Type'
                                search
                                closeOnChange
                                defaultValue={1}
                                style={{width: '30%', fontFamily: 'SFProText-Regular'}}
                                // inline
                                selection
                                options={[{key: 1, text: 'Stacked Bar Chart', value: 1},
                                        {key: 2, text: 'Group Chart', value: 2},
                                        ]}
                                onChange = {(e, value) => this.chartTypeChanged(e, value)} 
                            />
                            </span>
                </div>
            {/* {this.state.selected ? 
            <div ref={this.myRef}></div>
            :null} */}
                {this.state.selected ? 
                    <div>
                        <div ref = {this.pdfRef}>
                            {(this.state.chartType === 1 && this.state.stackChartData) ?
                                <StackChart data={this.state.stackChartData} title={"Active/Inactive Employees per Team"} description={this.state.description} />
                            :
                                (this.state.chartType === 2 && this.state.groupChartData) ?
                                    <GroupChart data={this.state.groupChartData} title={"Active/Inactive Employees per Team"} description={this.state.description} />
                                :
                                    null
                            }
                        </div>
                        {/* <div style={{}} >
                            <ReactToPdf x={0} y={0} targetRef={this.pdfRef.current} height={2000} filename="div-blue.pdf" options={{"orientation":'landscape', "format":'a4', margins : {
                                                                                                                top: 0,
                                                                                                                bottom: -170,
                                                                                                                left: 0,
                                                                                                                height: 2000,
                                                                                                                // width: '100%'
                                                                                                                }}}>
                                {({toPdf}) => (
                                    <button onClick={toPdf}>Generate pdf</button>
                                )}
                            </ReactToPdf>
                        </div> */}
                    </div>
                :
                    <div>No Data to Display</div>
                }
            </div>
        )
    }
}